import { render, staticRenderFns } from "./UpList.vue?vue&type=template&id=813f41f0&scoped=true&"
import script from "./UpList.vue?vue&type=script&lang=js&"
export * from "./UpList.vue?vue&type=script&lang=js&"
import style0 from "./UpList.vue?vue&type=style&index=0&id=813f41f0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813f41f0",
  null
  
)

export default component.exports